import {colors, fontsSize} from "../UIElements/Elements";

const WorkerStatusBar = ({workerName, outletName}) =>{


    return(
        <div className={` z-10 fixed top-0 left-0 w-full h-[8vh] px-[2vh] flex justify-between items-center text-white ${colors.secondary} ${fontsSize.m}`}>
               <div>{workerName} - {outletName} </div>
        </div>
    );
}

export default WorkerStatusBar